module.exports = __webpack_public_path__ + "img/edit-hover.d47bafb6.svg";